import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { Plazos, PlazosResponse } from "@p-p-portafolio/promociones/interfaces/plazos";
import { SwalService } from "@shared/utils/swal.service";
import { PlazosService } from "@p-p-portafolio/promociones/services/plazos.service";
import { ConfirmDeletionComponent } from "@shared/components/confirm-deletion/confirm-deletion.component";
import { Column } from "@shared/components/generic-table/types/column.type";
import { Row } from "@shared/components/generic-table/types/row.type";
import Swal from "sweetalert2";

@Component({
    selector: "app-plazos",
    templateUrl: "./plazos.component.html",
    styleUrls: ["./plazos.component.css"],
})
export class PlazosComponent implements OnInit {
    createForm: boolean = false;
    valueNew: number = 0;

    promocion = "";

    public dataSource: any = [];
    public loading: boolean = true;

    public columns = [
        { field: "iPlazo", header: "Plazo" },
        { field: "actions", header: "Acciones" },
    ];

    constructor(
        public dialog: MatDialog,
        private plazosService: PlazosService,
        private swalService: SwalService,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        const routeParams = this.route.snapshot.paramMap;
        this.promocion = String(routeParams.get("promocion"));

        this.getDataSource();
    }

    actionHandler(action: "create" | "update" | "delete", rowData?: any) {
        if (action === "create") {
            this.createAction();
        }

        if (action === "update") {
            this.swalService.error("Este dato no se puede actualizar");
        }

        if (action == "delete") {
            this.deleteAction(rowData);
        }
    }

    createAction() {
        this.plazosService.initializeFormGroup();
        this.createForm = true;
    }

    goBack() {
        window.history.back();
    }

    saveNew() {
        console.log(this.valueNew);
        this.plazosService
            .add({
                sPromocion: this.promocion,
                iPlazo: this.valueNew,
                numVar: 0,
            })
            .subscribe((res) => {
                if (res.success) {
                    this.swalService.success("Plazo añadido correctamente").then(() => {
                        this.getDataSource();
                        this.valueNew = 0;
                        this.createForm = false;
                    });
                } else {
                    this.swalService.error(res.errors[0]);
                }
            });
    }

    deleteAction(rowData) {
        Swal.fire({
            title: "Eliminar plazo",
            text: "¿Estas seguro de eliminar el plazo?",
            icon: "warning",
            showCancelButton: true,
            iconColor: "#d33",
            confirmButtonColor: "#d33",
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "No",
            heightAuto: false,
        }).then((result) => {
            if (result.isConfirmed) {
                const entity: Plazos = {
                    sPromocion: this.promocion,
                    iPlazo: rowData.iPlazo,
                    numVar: 0,
                }
                this.plazosService.delete(entity, this.promocion).subscribe((res) => {
                    if (res) {
                        this.swalService.success("Plazo eliminado correctamente").then(() => {
                            this.getDataSource();
                        });
                    } else {
                        this.swalService.error(res.errors[0]);
                    }
                });
            }
        });
    }

    getDataSource() {
        this.plazosService.getAll(this.promocion).subscribe((res) => {
            this.loading = false;
            this.dataSource = res;
        });
    }
}
